import React from "react";
import { styled, TableCell, TableRow } from "@mui/material";
import { useNavigate } from "react-router-dom";

const StyledTableRow = styled(TableRow)`
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

const AnnouncementsTableRow = ({
  announcement,
}) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`${announcement.announcementEntityId}`);
  };

  return (
    <StyledTableRow onClick={handleRowClick}>
      <TableCell component="th" scope="row">
        {announcement.createDate}
      </TableCell>
      <TableCell align="right">
        {announcement.label}
      </TableCell>
      <TableCell align="right">
        {announcement.sendDate ? "Sent" : "Not Sent"}
      </TableCell>
    </StyledTableRow>
  );
};

export default AnnouncementsTableRow;